import countries from "../data/countries.json";
import states from "../data/states.json";
import {
  auPhoneRegexp,
  auAndNzPostalCodeRegexp,
  caPostalCodeRegexp,
  usAndCaPhoneRegexp,
  usPostalCodeRegexp,
  gbPostalCodeRegexp,
  gbPhoneRegexp,
  prPostalCodeRegexp,
} from "./regexp";

type CountryInfo = {
  name: string;
  states: { value: string; label: string }[];
  phonePrefix: string;
  phoneRegexp: RegExp;
  getFormattedPhoneNumber: (phoneNumber: string) => string;
  postalCodeRegexp: RegExp;
  merchantCountryCode: string;
};

export function getCountryInfo(countryCode: string): CountryInfo {
  const countryName =
    countries.find((x) => x.value === countryCode)?.label ?? "";

  return {
    name: countryName,
    states: states.filter((x) => x.country === countryCode),
    phonePrefix: getPhonePrefix(countryCode),
    phoneRegexp: getPhoneRegexp(countryCode),
    getFormattedPhoneNumber: (phoneNumber: string) =>
      getFormattedPhoneNumber(phoneNumber, countryCode),
    postalCodeRegexp: getPostalCodeRegexp(countryCode),
    merchantCountryCode: getMerchantCountryCode(countryCode),
  };
}

function getFormattedPhoneNumber(number: string, countryCode: string): string {
  if (!number) return number;

  const phoneNumber = number.replace(/[^\d]/g, "");
  const phoneNumberLength = phoneNumber.length;

  switch (countryCode) {
    case "US":
    case "CA":
      if (phoneNumberLength < 4) return phoneNumber;
      if (phoneNumberLength < 7) {
        return `${phoneNumber.slice(0, 3)} ${phoneNumber.slice(3)}`;
      }
      return `${phoneNumber.slice(0, 3)} ${phoneNumber.slice(
        3,
        6
      )} ${phoneNumber.slice(6, 10)}`;
  }

  return number;
}

export function getPhonePrefix(countryCode: string): string {
  switch (countryCode) {
    case "US":
    case "CA":
    case "PR":
      return "+1";
    case "AU":
      return "+61";
    case "NZ":
      return "+64";
    case "GB":
      return "+44";
  }
  return "";
}

function getPhoneRegexp(countryCode: string) {
  switch (countryCode) {
    case "US":
    case "CA":
      return usAndCaPhoneRegexp;
    case "AU":
      return auPhoneRegexp;
    case "GB":
      return gbPhoneRegexp;
  }
  return /(?:)/;
}

function getPostalCodeRegexp(countryCode: string) {
  switch (countryCode) {
    case "US":
      return usPostalCodeRegexp;
    case "CA":
      return caPostalCodeRegexp;
    case "AU":
    case "NZ":
      return auAndNzPostalCodeRegexp;
    case "GB":
      return gbPostalCodeRegexp;
    case "PR":
      return prPostalCodeRegexp;
  }
  return /(?:)/;
}
function getMerchantCountryCode(countryCode: string): string {
  switch (countryCode) {
    case "US":
    case "CA":
    case "AU":
      return countryCode;
    case "GB":
      return "UK";
    case "PR":
      return "US";
  }
  return countryCode;
}
